export default __webpack_public_path__ + "static/media/alert_light.26bca5b5.svg";